function Lowercase({ input }) {

  return (
    <div className="output2">{input.toLowerCase()}</div>
  )
}

export default Lowercase;